import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BillingSessionManager from "./BillingSessionManager";
import BillingItemMasterManager from "./BillingItemMasterManager";

export default function BillingSettingsPage({
  schoolId,
  sessions,
  setSessions,
  sessionItems,
  setSessionItems,
  settingData,
  handleToastCenterTop,
  schoolYear,
  schoolYearId,
  billingApi,
  canCreate,
  canUpdate,
  canDelete,
}) {
  const { t } = useTranslation();
  const [selectedSessionId, setSelectedSessionId] = useState(null);

  return (
    <div>
      <div className="row mt-3">
        <div className="col-12 col-lg-7 mb-3">
          <BillingSessionManager
            schoolId={schoolId}
            sessions={sessions}
            setSessions={setSessions}
            settingData={settingData}
            schoolYearId={schoolYearId}
            initialSchoolYear={schoolYear}
            selectedSessionId={selectedSessionId}
            onSelectSession={setSelectedSessionId}
            handleToastCenterTop={handleToastCenterTop}
            billingApi={billingApi}
            canCreate={canCreate}
            canUpdate={canUpdate}
            canDelete={canDelete}
          />
        </div>
        <div className="col-12 col-lg-5">
          {selectedSessionId ? (
            <BillingItemMasterManager
              sessions={sessions}
              sessionItems={sessionItems}
              setSessionItems={setSessionItems}
              selectedSessionId={selectedSessionId}
              settingData={settingData}
              handleToastCenterTop={handleToastCenterTop}
              billingApi={billingApi}
              canCreate={canCreate}
              canUpdate={canUpdate}
              canDelete={canDelete}
            />
          ) : (
            <div className="text-muted mt-4 text-center">
              {t("billingManagement.labels.selectSessionForItems") ||
                "← 기간을 선택하면 항목이 표시됩니다."}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
